import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { useHistory } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as TablesQL from "queries/table";
import { Component as Form } from "@repoflow/form-schema";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import * as appWidgets from "@shared/widgets/register";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>New</BreadcrumbItem>;

// The name is the one field on this form that cannot be changed afterwards, and
// the form says so rather than letting the edit screen be the place somebody
// finds out. It is the range key, so a "rename" would write a second row and
// orphan the first — and it is also the identifier every saved SQL view will
// name, so a rename would break queries as well as rows.
//
// The columns are NOT asked for here. A create dialog that wants a schema is a
// form nobody finishes; you name the table, then declare its columns on its own
// screen. Same call wfws makes for a workflow's steps.
export const Content = ({ match: { params } }) => {
  const history = useHistory();
  const { base } = useSectionContext();

  const initial = {
    tableId: "",
    title: "",
    tags: [],
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/Table/Create" }}
      mutation={TablesQL.create}
      update={TablesQL.update(params)}
      onMutate={({ state: { values }, handler }) => {
        handler({ variables: { input: values } });
      }}
      onCompleted={(data) => {
        // The FIRST argument is the data itself — Mutation calls
        // `onCompleted(data, sectionContext)`, not `onCompleted({ data })`.
        // Destructured wrongly this is silently undefined, and the redirect
        // below quietly lands on the list instead of the table just made.
        const created = data?.viewer?.account?.tables?.create;
        // replace(), not goBack(): where you land should depend on what you
        // made, not on how you reached the form.
        history.replace(created ? `${base}/${created.tableId}/` : base);
      }}
      onError={(error) => {
        // The two id refusals the model makes are worth translating, because
        // both have an obvious fix and neither reads as one raw.
        const message = String(error);
        if (message.includes("table.create.reserved")) {
          const word = message.split("table.create.reserved:")[1] || "that word";
          Notify.error(`"${word}" is a SQL keyword, so a table cannot be called it — try a plural.`);
          return;
        }
        if (message.includes("table.create.invalid-id")) {
          Notify.error("A table name must start with a letter and use only lowercase letters, digits and underscores.");
          return;
        }
        if (message.includes("datum.create.exists")) {
          Notify.error("A table with that name already exists.");
          return;
        }
        Notify.error(message);
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

// The Mutation hands its children the section context — `schema`, `state`,
// `mutate`, `target` — and NOT a Fields component. The form is built here from
// those, which is the shape every other screen in this app uses.
const MutationHandler = ({ schema, state, mutate, target }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    values,
    widgets: appWidgets,
    onSubmit: () => mutate(),
    onChange: (vals) => setValues(vals),
    config: {
      "/Public/Table/Create": {
        fields: [
          { property: "title" },
          {
            property: "tableId",
            description:
              "Lowercase letters, digits and underscores. This is the name you will use in SQL, and it cannot be changed later.",
          },
          { property: "tags" },
        ],
      },
    },
  };

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Form {...formProps}>
            <Button type="submit">Create</Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
